// extracted by mini-css-extract-plugin
export var infoItem = "_tw-2";
export var title = "_tw-0";
export var value = "_tw-1";